import { matchTemplateRoomToProperty } from "@/data/checklistTemplates";
import { normalizeRoomName } from "@/lib/roomUtils";
import type { ListingScanPhoto } from "@/lib/listingPhotoScan";

/** One scan photo per room (first reference photo for that room). */
export function collectListingScanPhotos(
  referencePhotos: { room_name: string; photo_url: string }[],
  propertyRoomNames: string[]
): ListingScanPhoto[] {
  const seen = new Set<string>();
  const out: ListingScanPhoto[] = [];

  for (const ref of referencePhotos) {
    const url = ref.photo_url?.trim();
    const rawRoom = ref.room_name?.trim();
    if (!url || !rawRoom) continue;

    const roomName = matchTemplateRoomToProperty(rawRoom, propertyRoomNames);
    const key = normalizeRoomName(roomName);
    if (seen.has(key)) continue;
    seen.add(key);
    out.push({ url, roomName });
  }

  return out;
}

export function countListingScanRooms(photos: ListingScanPhoto[]): number {
  return new Set(photos.map((p) => normalizeRoomName(p.roomName))).size;
}
